import {Component, Input, OnInit} from '@angular/core';
import {StudyHistory} from "../../../types/interfaces";
import {AuthService} from "../../../services/mygreencountry/auth.service";
import {TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-dummy',
    templateUrl: './dummy.component.html',
    styleUrls: ['./dummy.component.scss'],
})
export class DummyComponent implements OnInit {

    @Input() type: string | undefined = undefined;
    @Input() isImageSmall: boolean = false;
    @Input() isImageBig: boolean = false;

    imagePath: string
    text: string
    public isParentRole: boolean = false;

    constructor(
        private authService: AuthService,
    ) {
        this.isParentRole = this.authService.isParentRole();
    }

    ngOnInit() {
        if (this.type) {
            this.imagePath = this.getImagePath(this.type, this.isParentRole);
            this.text = this.getText(this.type, this.isParentRole);
        }
    }


    getImagePath(type: string, isParent: boolean): string {
        switch (true) {
            case type === 'certificate' && isParent:
                return '/dummies/certificate.png';
            case type === 'certificate' && !isParent:
                return '/dummies/certificate.png';
            case type === 'study_history' && isParent:
                return '/dummies/study_history.png';
            case type === 'study_progress' && !isParent:
                return '/dummies/progress.png';
            case type === 'study_progress' && isParent:
                return '/dummies/progress.png';
            case type === 'schedule':
                return '/dummies/schedule.png';
            case type === 'no_active_tests':
                return '/dummies/no_active_tests.png';
            case type === 'no_completed_no_active':
                return '/dummies/no_completed_no_active.png';
            case type === 'no_completed_with_active':
                return '/dummies/no_completed_with_active.png';
            case type === 'no_expired_with_completed':
                return '/dummies/no_expired_with_completed.png';
            case type === 'no_expired_no_completed':
                return '/dummies/no_expired_no_completed.png';
            default:
                return '/dummies/certificate.png'; // Default return value
        }

    }

    getText(type: string, isParent: boolean): string {

        switch (true) {
            case type === 'certificate' && isParent:
                return 'dummy.parent.certificate';
            case type === 'certificate' && !isParent:
                return 'dummy.child.certificate';
            case type === 'study_history' && isParent:
                return 'dummy.parent.certificate';
            case type === 'study_progress' && !isParent:
                return 'dummy.child.progress';
            case type === 'study_progress' && isParent:
                return 'dummy.parent.progress';
            case type === 'schedule':
                return 'dummy.child.schedule';
            case type === 'no_active_tests':
                return 'dummy.child.noActiveTest';
            case type === 'no_completed_no_active':
                return 'dummy.child.noCompletedNoActive';
            case type === 'no_completed_with_active':
                return 'dummy.child.noCompletedWithActive';
            case type === 'no_expired_with_completed':
                return 'dummy.child.noExpiredWithCompleted';
            case type === 'no_expired_no_completed':
                return 'dummy.child.noExpiredNoCompleted';
            default:
                return ''; // Default return value
        }
    }

}
